import { SET_SIMULATE_MODE } from "../action.js";
import { isSimulateMode } from "./initial-store.js";

const initialState = isSimulateMode;

function simulateModeReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SIMULATE_MODE:
      return action.payload;
    default:
      return state;
  }
}

export default simulateModeReducer;
